module.exports = __webpack_public_path__ + "static/memberPriceImage-04cecbbd05eb6f622a6a486574ad38e7.png";